import { hasProjectReportFailed } from "@/utils";
import ReportError from "./error";

export default function ReportValidator({ project, children }) {
  if (hasProjectReportFailed(project)) return <ReportError />;

  return children;
}
